export default __webpack_public_path__ + "pgnv-assets/3e33c5fc3eb118258be6abf8a0177c8c.png";